import { NgModule } from '@angular/core';
import { UserSwitcherComponent } from '@firm/shared/components/user-switcher/user-switcher.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@shared/material/material.module';

@NgModule({
  declarations: [UserSwitcherComponent],
  imports: [CommonModule, FormsModule, MaterialModule],
  exports: [UserSwitcherComponent]
})
export class UserSwitcherModule { }
